import React from "react";
import { MenuItem, Typography } from "@mui/material";
import { People as PeopleIcon } from "@mui/icons-material";
import { PageHeaderCard } from "../../components/organisms";
import { FormSelect, SearchField } from "../../components/atoms";
import { useClinicTheme } from "../../theme";

const STATUS_OPTIONS = [
  { value: "", label: "Tümü" },
  { value: "Aktif", label: "Aktif" },
  { value: "Askıya Alındı", label: "Askıya Alındı" },
  { value: "Donduruldu", label: "Donduruldu" },
  { value: "Devre Dışı", label: "Devre Dışı" },
];

export default function StaffManagementHeader({
  counts,
  statusFilter,
  onStatusFilterChange,
  searchName,
  onSearchNameChange,
  searchEmail,
  onSearchEmailChange,
}) {
  const { palette } = useClinicTheme();

  return (
    <PageHeaderCard
      icon={<PeopleIcon sx={{ fontSize: 24 }} />}
      title="Personel Yönetimi"
      subtitle="Klinik personelini yönetin"
      statCards={[
        { label: "Toplam", value: counts[""], variant: "default" },
        { label: "Aktif", value: counts.Aktif, variant: "success" },
        {
          label: "Kısıtlı",
          value: (counts["Askıya Alındı"] || 0) + (counts.Donduruldu || 0),
          variant: "warning",
        },
      ]}
    >
      <FormSelect
        palette={palette}
        label="Durum"
        value={statusFilter}
        onChange={onStatusFilterChange}
        placeholder={null}
        fullWidth={false}
        sx={{ minWidth: 180 }}
      >
        {STATUS_OPTIONS.map((t) => (
          <MenuItem key={t.value || "all"} value={t.value}>
            {t.label}
            <Typography component="span" variant="caption" sx={{ ml: 1, color: "text.secondary" }}>
              ({counts[t.value] ?? 0})
            </Typography>
          </MenuItem>
        ))}
      </FormSelect>

      <SearchField
        label="İsim Ara"
        placeholder="Ad veya soyad"
        value={searchName}
        onChange={onSearchNameChange}
        autoComplete="off"
        sx={{ minWidth: 200, maxWidth: 280 }}
      />

      <SearchField
        label="E-posta Ara"
        placeholder="E-posta adresi"
        value={searchEmail}
        onChange={onSearchEmailChange}
        autoComplete="off"
        sx={{ minWidth: 200, maxWidth: 280 }}
      />
    </PageHeaderCard>
  );
}
